import Page from "@jumbo/shared/Page";
import TenantAdminRoute from "../../routes/TenantAdminRoute";
import CollaborationSpace from "./CollaborationSpace";
import ReferenceDownloader from "./ReferenceDownloader";
import FilingPackage371 from "./FilingPackage371";
import OAWorkflow from "./OAWorkflow/OAWorkflow";
import PGSWorkflow from "./OAWorkflow/PGSWorkflow";

import { getTenantName } from "app/utils/tenantUtils";

// const referenceDownloaderTenants = ["ops", "trexo-prod", "trexo-uat", "trexo-dev", "trexo dev", "trexo uat", "trexo prod", "trexo qa", "trexo qa admin"].map(tenant => tenant.toLowerCase());
const referenceDownloaderTenants = ["ops", "trexo-prod", "trexo-ops", "trexo-uat", "trexo-qa", "trexo-dev"];
//TODO: check if localStorage.getItem("TENANT_NAME") is in array referenceDownloaderTenants
const showReferenceDownloader = referenceDownloaderTenants.some(tenant => (window.location.host.split(".")[0])?.includes(tenant)) || process.env.NODE_ENV === "development";
const filing371Tenants = ["trexo-prod", "trexo-ops", "trexo-uat", "trexo-qa", "trexo-dev"];
const showFiling371 = filing371Tenants.some(tenant => (window.location.host.split(".")[0])?.includes(tenant)) || process.env.NODE_ENV === "development";

const oaWorkflowTenants = (process.env.REACT_APP_INTERNAL_TENANTS || "trexo-ops")
    .split(",").map(t => t.trim().toLowerCase());
const isOaWorkflowTenant = oaWorkflowTenants.includes(getTenantName()?.toLowerCase());

const Collaboration_routes = [

    {
        path: ["/collaboration-space", "/collaboration-space/my-files"],
        element: <TenantAdminRoute element={<Page component={CollaborationSpace} />} />
    },
    {
        path: ["/collaboration-space/workspace/*", "/collaboration-space/workspace/*"],
        element: <TenantAdminRoute element={<Page component={CollaborationSpace} />} />
    },
    {
        path: "/collaboration-space/my-files/*",
        element: <TenantAdminRoute element={<Page component={CollaborationSpace} />} />
    },
    {
        path: "/collaboration-space/shared/hash/*",
        element: <TenantAdminRoute element={<Page component={CollaborationSpace} />} />
    },
    {
        path: "/collaboration-space/shared/*",
        element: <TenantAdminRoute element={<Page component={CollaborationSpace} />} />
    },
    ...(showReferenceDownloader ? [{
        path: "/collaboration-space/reference-downloader/*",
        element: <TenantAdminRoute element={<Page component={ReferenceDownloader} />} />
    }] : []),
    ...(showFiling371 ? [{
        path: "/collaboration-space/371-filing-package/*",
        element: <TenantAdminRoute element={<Page component={FilingPackage371} />} />
    }] : []),
    ...(isOaWorkflowTenant ? [
        {
            path: "/collaboration-space/oa-workflow/*",
            element: <TenantAdminRoute element={<Page component={OAWorkflow} />} />
        },
        {
            path: "/collaboration-space/pgs-workflow/*",
            element: <TenantAdminRoute element={<Page component={PGSWorkflow} />} />
        }
    ] : []),

];

export default Collaboration_routes;